Directives.SvgBarChartDirective = function SvgBarChartDirective() {

    //@ngInject
    function SvgBarChartDirectiveControllerFunc($scope, $injector) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'SvgBarChartDirectiveController';

        this.fillColor = null;
        if (this.color) {
            this.fillColor = this.color;
        } else {
            this.fillColor = '#787878';
        }
    }

    var SvgBarChartDirectiveController = Class(Controllers.BaseController, {
        constructor: SvgBarChartDirectiveControllerFunc
    });

    return {
        restrict: 'E',
        scope: {
            color: '@?'
        },
        templateUrl : 'angular/app/modules/common/svgs/barchart/svg_barchart_directive_template.html',
        controller: SvgBarChartDirectiveController,
        controllerAs: 'svgBarChartVm',
        bindToController: true
    };
};
